var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.296 14.6231V5.70707C13.296 5.42261 13.0628 5.18945 12.7784 5.18945C12.4939 5.18945 12.2607 5.42261 12.2607 5.70707V14.6231C12.2607 14.9076 12.4939 15.1408 12.7784 15.1408C13.0628 15.1408 13.296 14.9123 13.296 14.6231Z",
    fill: "#E70000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9646 1.07617C6.38951 1.07617 1.03613 6.42955 1.03613 13.0094C1.03613 19.5892 6.38951 24.9379 12.9646 24.9379C15.9724 24.9379 18.845 23.814 21.0507 21.7809C21.2605 21.5897 21.2745 21.2586 21.0786 21.0487C20.8828 20.8389 20.5564 20.8249 20.3465 21.0208C18.3274 22.8814 15.7066 23.9073 12.96 23.9073C6.95842 23.9026 2.07137 19.0156 2.07137 13.0094C2.07137 7.00312 6.95842 2.11141 12.9646 2.11141C18.9709 2.11141 23.8626 6.99846 23.8626 13.0094C23.8626 15.0472 23.2983 17.029 22.2305 18.7498C22.0812 18.9923 22.1559 19.3094 22.3983 19.4632C22.6408 19.6125 22.9579 19.5379 23.1118 19.2954C24.2823 17.4114 24.9025 15.2384 24.9025 13.0094C24.8978 6.42955 19.5445 1.07617 12.9646 1.07617Z",
    fill: "#E70000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7617 18.1912C11.7617 18.7554 12.2187 19.2124 12.783 19.2124C13.3472 19.2124 13.8042 18.7554 13.8042 18.1912C13.8042 17.6269 13.3472 17.1699 12.783 17.1699C12.2187 17.1699 11.7617 17.6269 11.7617 18.1912Z",
    fill: "#E70000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention2);
export default __webpack_public_path__ + "static/media/attention_2.d78376565a2674c5170edf6b9c77998f.svg";
export { ForwardRef as ReactComponent };